<script setup>
import { computed, inject } from 'vue';
import SubHead from '@/components/result/SubHead.vue';
import SubArea from '@/components/result/SubArea.vue';
import AnswerRates from '@/components/result/AnswerRates.vue';
import SubareaAnalysis from '@/components/result/SubareaAnalysis.vue'; 

import literacyGraph02 from '@/assets/images/result/literacy_graph_02.png';

// 부모에서 주입받은 데이터
const studentData = inject('studentData');
const loading = inject('loading');

const pagetype = "literacy";
const region = "seoul";
const userRole = "student";

// API 데이터를 기반으로 한 computed 값들
const studentName = computed(() => {
    return studentData.value?.name || '로딩중...';
});

// 문해력 영역별 정답률 (korsub1~4: 어휘, 비판및평가, ?, ?)
// API 데이터에서 _rate가 붙은 필드 사용
const ourClassPercentages = computed(() => {
    if (!studentData.value) return [-1, -1, -1, -1];
    
    return [
        parseInt(studentData.value.korsub1_rate) || -1,  // 어휘
        parseInt(studentData.value.korsub2_rate) || -1,  // 비판및평가
        parseInt(studentData.value.korsub3_rate) || -1,  // 영역3
        parseInt(studentData.value.korsub4_rate) || -1   // 영역4
    ];
});

// 전체 정답률 (korsub1_total_rate~4)
const overallPercentages = computed(() => {
    if (!studentData.value) return [0, 0, 0, 0];
    
    return [
        parseInt(studentData.value.korsub1_total_rate) || 0,  // 어휘
        parseInt(studentData.value.korsub2_total_rate) || 0,  // 비판및평가  
        parseInt(studentData.value.korsub3_total_rate) || 0,  // 영역3
        parseInt(studentData.value.korsub4_total_rate) || 0   // 영역4
    ];
});

// 각 영역별 안전도 (안전, 경계, 주의)
const subAreaLevels = computed(() => {
    if (!studentData.value) return ['', '', '', ''];
    
    return [
        studentData.value.korsub1_level || '',  // 어휘
        studentData.value.korsub2_level || '',  // 비판및평가
        studentData.value.korsub3_level || '',  // 영역3
        studentData.value.korsub4_level || ''   // 영역4
    ];
});
</script>

<template lang="">
    <div class="slide-inner">
        <div class="content">    
            <SubHead :type="pagetype" :region="region" :hideTitleBox="true" />
             <div class="card-wrap">
                <SubArea 
                    :type="pagetype" 
                    :region="region" 
                    :userRole="userRole" 
                    :isStudent="true"
                    :subAreaLevels="subAreaLevels"
                />
                <AnswerRates
                    :type="pagetype" 
                    :graph-src="literacyGraph02"
                    :our-class-percentages="ourClassPercentages"
                    :overall-percentages="overallPercentages"
                    :isStudent="true"
                    :userRole="userRole"
                />
                <SubareaAnalysis 
                    :type="pagetype"
                    :studentName="studentName"
                    :subAreaLevels="subAreaLevels"
                    :schoolType="studentData?.schul_type || 'E'"
                    :grade="parseInt(studentData?.grade_code) || 4"
                />
            </div>
        </div>
    </div>
</template>